// extracted by mini-css-extract-plugin
module.exports =  {"thumbnailButton":"yaRf8SlhN1w176nnzTQ1","thumbnailImage":"NoVWtzN7x_dQzyhRVHGE","spinner":"xAEOdnnJk5Wf3NVhEiZ8","playIcon":"LAQKV6Oy8nmhWo2EE2rV"};